import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { Field, reduxForm, FieldArray } from 'redux-form'
import { getLists } from '../../state/lists'
import { FormButtons, renderers, validations, Loading } from '../../components'
import AddOptionsFormPane from '../OptionsManagement/AddOptionsFormPane'
import { dynamicSort } from '../../helpers'
const getFormItems = (enableBulkMode, descriptions) => {
  return enableBulkMode ? (
    <FieldArray
      descriptions={descriptions}
      name="inventory_items"
      component={renderItems}
    />
  ) : (
    <div>
      <Field
        name="description"
        as="select"
        validate={[validations.required]}
        component={renderers.renderSelectField}
        label="Description"
      >
        {descriptions &&
          descriptions.map((x) => (
            <option key={x.url} value={x.value}>
              {x.value}
            </option>
          ))}
      </Field>

      <Field
        name="quantity"
        type="text"
        validate={[validations.required, validations.number]}
        component={renderers.renderField}
        label="Quantity"
      />
      <Field
        name="part_number"
        type="text"
        component={renderers.renderField}
        label="Part Number"
      />
    </div>
  )
}
const renderItems = ({
  fields,
  descriptions,
  meta: { error, submitFailed },
}) => {
  if (fields.length === 0) {
    fields.push({})
  }
  return (
    <ReactBootstrap.Col className="mt-5 p-0">
      <ReactBootstrap.ListGroup>
        {fields.map((member, index) => (
          <div>
            <ReactBootstrap.ListGroupItem key={index}>
              <ReactBootstrap.Row>
                <ReactBootstrap.Col xs={12} md={4}>
                  <Field
                    name={`${member}.description`}
                    as="select"
                    validate={[validations.required]}
                    component={renderers.renderSelectField}
                    label="Description"
                  >
                    {descriptions &&
                      descriptions.sort(dynamicSort('value')).map((x) => (
                        <option key={x.url} value={x.value}>
                          {x.value}
                        </option>
                      ))}
                  </Field>
                </ReactBootstrap.Col>
                <ReactBootstrap.Col xs={12} md={4}>
                  <Field
                    name={`${member}.part_number`}
                    type="text"
                    component={renderers.renderField}
                    label="Part Number"
                  />
                </ReactBootstrap.Col>
                <ReactBootstrap.Col xs={12} md={4}>
                  <Field
                    name={`${member}.quantity`}
                    type="text"
                    validate={[validations.required, validations.number]}
                    component={renderers.renderField}
                    label="Quantity"
                  />
                </ReactBootstrap.Col>

                {fields.length > 1 ? (
                  <ReactBootstrap.Button
                    variant="link"
                    style={{ float: 'right' }}
                    title="Remove Member"
                    onClick={() => fields.remove(index)}
                  >
                    Remove
                  </ReactBootstrap.Button>
                ) : (
                  ''
                )}
              </ReactBootstrap.Row>
            </ReactBootstrap.ListGroupItem>
          </div>
        ))}
        <ReactBootstrap.ListGroupItem>
          <ReactBootstrap.Button
            style={{ float: 'right' }}
            variant="link"
            size="md"
            onClick={() => fields.push({})}
          >
            Add More
          </ReactBootstrap.Button>
          {submitFailed && error && <span>{error}</span>}
        </ReactBootstrap.ListGroupItem>
      </ReactBootstrap.ListGroup>
    </ReactBootstrap.Col>
  )
}
let SerializableInventoryForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  enableBulkMode,
  dispatch,
  rights,
  serializable_inventory_item,
  consignment_type,
}) => {
  return (
    <>
      <div className="text-end">
        <AddOptionsFormPane
          title="Add New Item"
          selectedType="SERIALIZABLE_INVENTORY_ITEM"
          OnSuccess={() => dispatch(getLists('SERIALIZABLE_INVENTORY_ITEM'))}
        />
      </div>
      <form onSubmit={handleSubmit}>
        <ReactBootstrap.Col xs="12">
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="organization"
            label="Organization"
          >
            {rights &&
              rights
                .filter((x) => x.is_active && x.non_serialized_inventory === true)
                .map((opt) => (
                  <option key={opt.organization_code} value={opt.organization}>
                    {opt.organization_code}-{opt.organization_name}
                  </option>
                ))}
          </Field>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="consignment_type"
            label="Consignment Type"
          >
            {consignment_type &&
              consignment_type.map((x) => (
                <option key={x.url} value={x.value}>
                  {x.value}
                </option>
              ))}
          </Field>
          {serializable_inventory_item ? (
            getFormItems(enableBulkMode, serializable_inventory_item)
          ) : (
            <Loading />
          )}
          <FormButtons
            submitting={submitting}
            pristine={pristine}
            reset={reset}
          />
        </ReactBootstrap.Col>
      </form>
    </>
  )
}
SerializableInventoryForm = reduxForm({
  form: 'serializable-inventory-form',
  enableReinitialize: true,
})(SerializableInventoryForm)

export default SerializableInventoryForm
